import React from "react";
import { ConfigProvider } from "antd";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import dayjs from "dayjs";
import viVN from "antd/locale/vi_VN";
import { antdTheme } from "app/theme/theme";
import AppRoutes from "app/router/Routes";
import { AuthProvider } from "app/contexts/AuthContext";
import "dayjs/locale/vi";

dayjs.locale("vi");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  return (
    <ConfigProvider locale={viVN} theme={antdTheme}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </QueryClientProvider>
    </ConfigProvider>
  );
};

export default App;
